// src/components/HowItWorksSection.jsx
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import FeatureCard from './ui/FeatureCard'; // <--- IMPORTA EL NUEVO COMPONENTE
import { faUserCheck, faBrain, faClipboardList, faSearchPlus } from '@fortawesome/free-solid-svg-icons';
// Ya no necesitas FontAwesomeIcon aquí si FeatureCard lo maneja

const HowItWorksSection = () => {
    const appName = "MyFit Menu AI"; // O el nombre de tu app

    const steps = [
        {
            icon: faUserCheck,
            title: "1. Create Your Profile",
            text: "Tell us about yourself: your age, physical metrics, activity level, dietary preferences (including allergies), and most importantly, your health and fitness goals."
        },
        {
            icon: faBrain,
            title: "2. AI Tailors Your Plan",
            text: `Our intelligent algorithms analyze your unique data to calculate your precise daily calorie, protein, and macronutrient needs. ${appName} then crafts your personalized nutrition and fitness strategies.`
        },
        {
            icon: faClipboardList,
            title: "3. Receive & Customize",
            text: "Get your AI-generated meal plans, delicious recipes, and effective workout routines. You can adjust your calorie and macro targets at any time to fine-tune your journey."
        },
        {
            icon: faSearchPlus,
            title: "4. Scan & Understand",
            text: `Use our smart food scanner (image & barcode) for instant nutritional insights on-the-go. Make informed choices and stay on track with ${appName}.`
        }
    ];

    return (
        <section className="how-it-works py-5">
            <Container>
                <Row className="text-center mb-5">
                    <Col>
                        <h2 className="fw-bold display-5">Getting Started with {appName} is Easy</h2>
                        <p className="text-muted fs-5">
                            Follow these simple steps to unlock your personalized health and fitness journey.
                        </p>
                    </Col>
                </Row>
                <Row className="g-4 justify-content-center">
                    {steps.map((step, index) => (
                        <Col md={6} lg={3} key={index} className="d-flex"> {/* d-flex para igualar altura */}
                            <FeatureCard
                                icon={step.icon}
                                title={step.title}
                                text={step.text}
                                // Props con valores por defecto en FeatureCard, pero puedes sobreescribirlas aquí si es necesario:
                                // iconSize="2x"
                                // iconContainerClass="icon-circle bg-success text-white mb-3 mx-auto"
                                // cardClassName="h-100 text-center shadow-sm border-0 p-3 feature-card-hover" // Renombré a feature-card-reusable en el CSS
                                // titleAs="h3"
                                // titleClassName="fw-bold fs-5 mb-3"
                                // textClassName="text-muted small"
                                cardClassName="h-100 text-center shadow-sm border-0 p-3 feature-card-reusable" // Asegúrate que la clase para hover coincida
                            />
                        </Col>
                    ))}
                </Row>
            </Container>
            {/* El estilo <style jsx global> ya no es necesario aquí si los estilos .icon-circle y 
                .feature-card-reusable:hover están en tu CSS global. */}
        </section>
    );
};

export default HowItWorksSection;